module.exports = "images/maximum-engineering_poster@2x.webp";